import React, { createContext, useContext, useState, useEffect } from "react";
import { getSession } from "../service/auth";
import { getUserProfile, getEmployeeByUserId } from "../service/rpc";

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const session = getSession();
  const [userData, setUserData] = useState({
    uid: session?.uid || null,
    partnerId: null,
    employeeId: null,
    isPortal: false,
    name: null,
    profileType: null,
    loading: true,
    error: null,
  });
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshUser = () => setRefreshKey(prev => prev + 1);

  useEffect(() => {
    async function loadUserMetaData() {
      if (!session?.uid) {
        setUserData(prev => ({ ...prev, loading: false }));
        return;
      }

      try {
        setUserData(prev => ({ ...prev, loading: true }));
        const [profile, employee] = await Promise.all([
          getUserProfile(session.uid).catch(() => null),
          getEmployeeByUserId(session.uid).catch(() => null),
        ]);

        setUserData({
          uid: session.uid,
          partnerId: profile?.id || null,
          employeeId: employee?.id || null,
          isPortal: profile?.isPortal || false,
          name: profile?.name || session.name || "User",
          profileType: profile?.profile_type || null,
          loading: false,
          error: null,
        });
      } catch (err) {
        console.error("Failed to load user metadata:", err);
        setUserData(prev => ({ ...prev, loading: false, error: err.message }));
      }
    }

    loadUserMetaData();
  }, [session?.uid, refreshKey]);

  return (
    <UserContext.Provider value={{ ...userData, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
